import { PersonalInfo } from '../../../member-profile/components/PersonalInfo';

const PersonalInfoScreen = () => {
    return <PersonalInfo />;
};

export default PersonalInfoScreen;
